import { render } from "./UploadDocuments.vue?vue&type=template&id=06fe9e67&scoped=true"
import script from "./UploadDocuments.vue?vue&type=script&lang=js"
export * from "./UploadDocuments.vue?vue&type=script&lang=js"

import "./UploadDocuments.vue?vue&type=style&index=0&id=06fe9e67&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fe9e67"]])

export default __exports__